import { toast } from 'react-toastify';

const toastUtil = {
  success: (message) => toast.success(message, {
    style: {
      borderRadius: '8px',
      padding: '15px',
      fontSize: '13px',
    },
    progressClassName: "progress-bar-custom"
  }),
  error: (message) => toast.error(message, {
    style: {
      borderRadius: '8px',
      padding: '15px',
      fontSize: '13px',
    },
    progressClassName: "progress-bar-custom",
  }),
  info: (message) => toast.info(message, {
    style: {
      borderRadius: '8px',
      padding: '15px',
      fontSize: '13px',
    },
    progressClassName: "progress-bar-custom"
  }),
  warning: (message) => toast.warning(message, {
    style: {
      borderRadius: '8px',
      padding: '15px',
      fontSize: '13px',
    },
    progressClassName: "progress-bar-custom"
  }),
  dark: (message) => toast.dark(message),
};

export default toastUtil;